/**
 * Created by csaba.adam on 2017. 07. 18..
 */
export default function () {
	return function (number) {
		return Number.isInteger(parseInt(number)) ? parseInt(number).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '';
	};
}
